import { Component, OnInit, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';
import { forkJoin } from 'rxjs';
import { concatMap } from 'rxjs/operators';
@Component({
  selector: 'app-delete-smspdp-live-data',
  templateUrl: './delete-smspdp-live-data.component.html',
  styleUrls: ['./delete-smspdp-live-data.component.scss']
})
export class DeleteSmspdpLiveDataComponent implements OnInit {
  itemData:any;
  yesFlag: boolean;
  apiUrl: any;
  dd:string;

  constructor(public dialogRef: MatDialogRef<DeleteSmspdpLiveDataComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,private dialog: MatDialog,
    private endpointsService:EndpointsService,private backendApiService : BackendApiService,private router: Router) { }

  ngOnInit(): void {
    this.itemData =this.data.rowData;
    console.log("this.orgId",this.itemData.orgId)
  }
  clickNo() {
    this.dialogRef.close();
  }
  clickYes() {
    // let deleteRequests = [
    //   this.backendApiService.callToApi(this.endpointsService.URL_DELETE_SMSPDP_CONFIG + '&orgId=' + this.itemData.orgId),
    //   this.backendApiService.callToApi(this.endpointsService.URL_DELETE_ECOWAS_SMSPDP_CONFIG + '&orgId=' + this.itemData.orgId),
    //   this.backendApiService.callToApi(this.endpointsService.URL_DELETE_SMSPDP_LIVE_MAPPING_CONFIG + '&orgId=' + this.itemData.orgId),
    //   this.backendApiService.callToApi(this.endpointsService.URL_DELETE_SMSPDP_THRESOLD_CONFIG + '&orgId=' + this.itemData.orgId),
    //   this.backendApiService.callToApi(this.endpointsService.URL_DELETE_SMSPDP_TABLEDATA + '&orgId=' + this.itemData.orgId + '&table=smspdp_live_mapping_copy')
      
    // ];
    // forkJoin(deleteRequests)
    //    .subscribe(
    //     (responses :any[]) => {
    //       const response1 = responses[0];
    //       const response2 = responses[1];
    //       const response3 = responses[2];
    //       const response4 = responses[3];
    //       const response5 = responses[4];

    //       alert("Service Deleted Successfully"); 
    //       this.dialogRef.close();
    //     },

    //     (error) => {
    //       console.error('Error occurred:', error);
    //       return;
    //     }
    //    )



    let apiurl1 = this.endpointsService.URL_DELETE_ECOWAS_ORGANIZATION_CONFIG;
    let apiurl2 = this.endpointsService.URL_DELETE_BUSINESS_CONFIG;
    let apiurl3 = this.endpointsService.URL_DELETE_ECOWAS_THRESHOLD_CONFIG;
    let apiurl4 = this.endpointsService.URL_DELETE_RRMS_PROBDB_CC_NDC;


    let apiurl5 = this.endpointsService.URL_DELETE_RRMS_PROBDB_MCC_MNC;

    // let apiurl6 = this.endpointsService.URL_DELETE_RRMS_PROBRDB_ALLOWED_GT;
    let apiurl7 = this.endpointsService.URL_DELETE_SMSPDP_LIVE_MAPPING_CONFIG;
    // let apiurl11 = this.endpointsService.URL_DELETE_ECOWAS_THRESHOLD_CONFIG;
    // let apiurl12 = this.endpointsService.URL_DELETE_RRMS_PROBRDB_ALLOWED_GT;
    // let apiurl13 = this.endpointsService.URL_DELETE_RRMS_PROBDB_CC_NDC;
    // let apiurl14 = this.endpointsService.URL_DELETE_RRMS_PROBDB_MCC_MNC;
    //  let apiurl15 = this.endpointsService.URL_DELETE_RRMS_PROBDB_ORGANIZATION;
    //  let apiurl16 = this.endpointsService.URL_DELETE_WHITELIST_CONFIG;


    let apiurl8 = this.endpointsService.URL_DELETE_SMSPDP_TABLEDATA;
    

    if(this.itemData.orgId){
     // apiurl1 +=  '&orgId=' + this.itemData.orgId ;
      apiurl2 +=  '&orgId=' + this.itemData.orgId ;
      apiurl3 +=  '&orgId=' + this.itemData.orgId ;
      // apiurl4 +=  '&orgId=' + this.itemData.orgId ;
      // apiurl5 +=  '&orgId=' + this.itemData.orgId ;
      //apiurl6 +=  '&orgId=' + this.itemData.orgId ;
      apiurl7 +=  '&orgId=' + this.itemData.orgId ;     
      apiurl8 +=  '&orgId=' + this.itemData.orgId ;
    
     
    }
    if(this.itemData.roamOrgId){
      apiurl1 +=  '&roamOrgId=' + this.itemData.roamOrgId ;
      apiurl2 +=  '&roamOrgId=' + this.itemData.roamOrgId ;
      apiurl3 +=  '&roamOrgId=' + this.itemData.roamOrgId ;
      apiurl4 +=  '&roamOrgId=' + this.itemData.roamOrgId ;
      apiurl5 +=  '&roamOrgId=' + this.itemData.roamOrgId ;
      //apiurl6 +=  '&roamOrgId=' + this.itemData.roamOrgId ;     
      apiurl7 +=  '&vistingOrgId=' + this.itemData.roamOrgId ;
      apiurl8 +=  '&roamOrgId=' + this.itemData.roamOrgId ;
    }
    if(this.itemData.type){
      apiurl1 +=  '&type=' + this.itemData.type ;
      apiurl2 +=  '&type=' + this.itemData.type ;
      apiurl3 +=  '&type=' + this.itemData.type ;
      apiurl4 +=  '&type=' + this.itemData.type ;

      apiurl5 +=  '&type=' + this.itemData.type ;
      //apiurl6 +=  '&type=' + this.itemData.type ;
      apiurl7 +=  '&type=' + this.itemData.type ;
      
     
      
      
      apiurl8 +=  '&type=' + this.itemData.type + '&table=smspdp_live_mapping';
     
    }
    // if(this.itemData.msisdn){
    //   apiurl16 +=  '&msisdn=' + this.itemData.msisdn ;
    // }
    // if(this.itemData.gt){
    //   apiurl6 +=  '&gt=' + this.itemData.gt
      
    // }

    this.delapiurl1(apiurl1);
    this.delapiurl2(apiurl2)
    this.delapiurl3(apiurl3)
    this.delapiurl4(apiurl4)

    this.delapiurl5(apiurl5)
//this.delapiurl9(apiurl6)
this.delapiurl7(apiurl7)
//this.delapiurl8(apiurl8)


    
    this.backendApiService.callToApi(apiurl8).subscribe(response => {
      console.log("res",response)
      if (response){
        console.log("resssssss",response)
        alert("Deleted Sucessfully");
        return;
      }
    }, (err) => {
      alert("Deleted Sucessfully");
      this.onReset();
    });





  //   forkJoin(deleteRequests)
  //   .pipe(
  //     concatMap((responses: any[]) => {
        
  //       console.log('Responses:', responses);

       
  //       const deletionPromises = responses.map(response => {
         
  //       });

  //       return Promise.all(deletionPromises);
  //     })
  //   )
  //   .subscribe(
  //     () => {
        
  //       alert('Deletion completed');
  //     },
  //     (error) => {
        
  //       console.error('Error occurred:', error);
  //     }
  //   );
  
   }
   delapiurl1(apiurl1){
    this.backendApiService.callToApi(apiurl1).subscribe(response => {
     console.log(response)
     });
  }
  delapiurl2(apiurl2){
    this.backendApiService.callToApi(apiurl2).subscribe(response => {
     console.log(response)
     });
  }
  delapiurl3(apiurl3){
    this.backendApiService.callToApi(apiurl3).subscribe(response => {
     console.log(response)
     });
  }
  delapiurl4(apiurl4){
    this.backendApiService.callToApi(apiurl4).subscribe(response => {
     console.log(response)
     });
  }
  delapiurl5(apiurl5){
    this.backendApiService.callToApi(apiurl5).subscribe(response => {
     console.log(response)
     });
  }

  delapiurl6(apiurl6){
    this.backendApiService.callToApi(apiurl6).subscribe(response => {
     console.log(response)
     });
  }
  delapiurl7(apiurl7){
    this.backendApiService.callToApi(apiurl7).subscribe(response => {
     console.log(response)
     });
  }
  // delapiurl11(apiurl11){
  //   this.backendApiService.callToApi(apiurl11).subscribe(response => {
  //    console.log(response)
  //    });
  // }
  // delapiurl12(apiurl12){
  //   this.backendApiService.callToApi(apiurl12).subscribe(response => {
  //    console.log(response)
  //    });
  // }
  // delapiurl13(apiurl13){
  //   this.backendApiService.callToApi(apiurl13).subscribe(response => {
  //    console.log(response)
  //    });
  // }
  // delapiurl14(apiurl14){
  //   this.backendApiService.callToApi(apiurl14).subscribe(response => {
  //    console.log(response)
  //    });
  // }
  // delapiurl15(apiurl15){
  //   this.backendApiService.callToApi(apiurl15).subscribe(response => {
  //    console.log(response)
  //    });
  // }
  // delapiurl16(apiurl16){
  //   this.backendApiService.callToApi(apiurl16).subscribe(response => {
  //    console.log(response)
  //    });
  // }
  onReset() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
    // this.spinnerService.show();
  }

}
